// src/layout/MainLayout/Header/HeaderContent/Profile/ProfileTab.js
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

// material-ui
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

// assets
import { LogoutOutlined, UserOutlined, SettingOutlined } from '@ant-design/icons';
import { useAuth } from 'contexts/AuthContext';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

const ProfileTab = ({ handleLogout }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleNavigateToProfile = () => {
    navigate('/profile');
  };

  const handleNavigateToSettings = () => {
    navigate('/admin/settings');
  };

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      <ListItemButton onClick={handleNavigateToProfile}>
        <ListItemIcon>
          <UserOutlined />
        </ListItemIcon>
        <ListItemText primary="View Profile" />
      </ListItemButton>

      {user?.role === 'admin' && (
        <ListItemButton onClick={handleNavigateToSettings}>
          <ListItemIcon>
            <SettingOutlined />
          </ListItemIcon>
          <ListItemText primary="Settings" />
        </ListItemButton>
      )}

      {/* {user?.role === 'vendor' && user?.vendor && (
        <ListItemButton disabled>
          <ListItemIcon>
            <WalletOutlined />
          </ListItemIcon>
          <ListItemText primary={`Company: ${user.vendor.company_name}`} />
        </ListItemButton>
      )}

      {user?.role === 'client' && user?.client && (
        <ListItemButton disabled>
          <ListItemIcon>
            <WalletOutlined />
          </ListItemIcon>
          <ListItemText primary={`Company: ${user.client.company_name}`} />
        </ListItemButton>
      )} */}

      <ListItemButton onClick={handleLogout}>
        <ListItemIcon>
          <LogoutOutlined />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </ListItemButton>
    </List>
  );
};

ProfileTab.propTypes = {
  handleLogout: PropTypes.func
};

export default ProfileTab;
